import envConfig from '../../../config';
import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { ReservationById } from '../api-types';

export const name: string = 'rides';

export const types = {
    GET_RIDE: name + '/GET_RIDE',
};

interface ReservationState {
    rides: ReservationById;
}

const initialState: ReservationState = {
    rides: {} as ReservationById,
};

const reducer = (state = initialState, action): ReservationState => {
    const payload = action.payload;
    const parameters = action.parameters;
    const id = parameters ? parameters.id : 0;

    switch (action.type) {
        case types.GET_RIDE:
            return {
                ...state,
                rides: { ...state.rides, [id]: payload },
            };
        // case types.CANCEL_RESERVATION:
        //     return {
        //         ...state,
        //         rides: { ...state.rides, [id]: payload }, // Not consistent with get
        //     };
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    getRide: (id) =>
        fetchAction(CoreAPIService.get(`internal/rides/${id}`, null, null, envConfig.privapi_url), types.GET_RIDE, {
            id,
        }),
};

const localState = (state: any): ReservationState => state[name] || initialState;
export const selectors = {
    rides: (state) => localState(state).rides,
};
